import {FaCircleInfo} from "react-icons/fa6";
import {useState} from "react";
import {Modal} from "../../../../components/modal/modal.jsx";
import ModalBody from "../../../../components/modal/modal-body.jsx";
import ModalFooter from "../../../../components/modal/modal-footer.jsx";
import Button from "../../../../components/button/button.jsx";

const GeoreferencedSearchMobileDetails = ({mobileInfo}) => {
    const [showModal, setShowModal] = useState(false);

    return (
        <>
            <span onClick={() => setShowModal(true)} className="absolute right-0 -top-5 cursor-pointer"><FaCircleInfo size={16}/></span>
            <Modal title="Dados do dispositivo" open={showModal} setOpen={setShowModal} className="w-3/12">
                <ModalBody>
                    <div className="px-6 py-4">
                        <table className="w-full border-collapse">
                            <tbody className="divide-y divide-gray-200 border-t border-gray-200">
                            <tr>
                                <td className="py-2 text-sm font-medium text-gray-600 w-1/3">
                                    Usuário
                                </td>
                                <td className="py-2 text-sm text-gray-800">
                                    {mobileInfo?.deviceinfo?.username ?? ""}
                                </td>
                            </tr>
                            <tr>
                                <td className="py-2 text-sm font-medium text-gray-600">
                                    Número
                                </td>
                                <td className="py-2 text-sm text-gray-800">
                                    {mobileInfo?.deviceinfo?.phone ?? ""}
                                </td>
                            </tr>
                            <tr>
                                <td className="py-2 text-sm font-medium text-gray-600">
                                    Latitude
                                </td>
                                <td className="py-2 text-sm text-gray-800">
                                    {mobileInfo?.loc?.lat ?? ""}
                                </td>
                            </tr>
                            <tr>
                                <td className="py-2 text-sm font-medium text-gray-600">
                                    Longitude
                                </td>
                                <td className="py-2 text-sm text-gray-800">
                                    {mobileInfo?.loc?.lng ?? ""}
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </ModalBody>
                <ModalFooter>
                </ModalFooter>
            </Modal>
        </>
    );
}

export default GeoreferencedSearchMobileDetails;